var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 192.756 192.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h192.756v192.756H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.252 96.378c-.189 19.433-39.34 32.61-87.874 32.61-48.535 0-87.874-12.229-87.874-33.842 0-17.916 39.339-31.377 87.874-31.377 48.534 0 88.159 13.366 87.874 32.609z",
    fill: "#c82e37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M84.245 87.941h4.834v13.555h13.46v2.275H84.245v-15.83zM127.375 87.941h4.74v6.636h14.598v-6.636h4.74v16.116h-4.74v-7.205h-14.598v7.205h-4.74V87.941zM154.676 103.961h5.119v-16.02h-5.119v16.02zM40.734 87.941c21.234 0 21.897 16.02.095 16.02H29.927v-16.02h10.807z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.208 90.216c14.029-.284 14.029 11.661-.095 11.471h-6.351V90.216h6.446z",
    fill: "#c82e37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.527 87.941c13.176 0 13.176 9.67-.191 9.67h-6.16v6.35h-4.834v-16.02h11.185z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.674 90.216c7.203 0 7.299 5.214 0 5.214h-5.404v-5.214h5.404z",
    fill: "#c82e37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.59 90.69c-6.541-1.707-16.778-1.517-18.2 3.792h12.892v1.99H63.39c1.896 7.963 18.295 4.645 18.295 4.645l.379 2.371s-23.319 3.506-24.078-7.963c1.043-9.385 18.959-8.626 24.078-7.204l-.474 2.369zM162.26 101.496v.285h.853v2.18h.379v-2.18h.854v-.285h-2.086zM164.82 101.496v2.465h.379v-2.084l.758 2.084h.285l.758-2.084v2.084h.379v-2.465h-.568l-.76 2.086-.662-2.086h-.569zM96.378 67.94v7.868s-94.509-2.18-80.859 27.206c0 0-22.561-30.24 80.859-35.074z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.757 125.102v-7.869s94.51 2.182 80.86-27.206c0 0 22.465 30.239-80.86 35.075z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo05);
export default __webpack_public_path__ + "static/media/logo05.1ba307993d6b069afdc59c9cc08838f7.svg";
export { ForwardRef as ReactComponent };